import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Permission } from '@core/enums/permissions';
import { AuthService } from '@core/services/auth.service';
import { LookupService } from '@core/services/lookup.service';
import { take } from 'rxjs';
import { IVendor } from '@core/interfaces/ivendor';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-integrations',
    templateUrl: './integrations.component.html',
    styleUrls: ['./integrations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationsComponent implements OnInit {
  tableData?: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  hasFullAccess?: boolean;

  tableColumns: any[] = [];
  public get Permission() {
    return Permission;
  }
  constructor(
    private lookupService: LookupService,
    public modal: MatDialog,
    public authService: AuthService,
    private router: Router,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.tableColumns = [
      { columnDef: 'name', header: this.translocoService.translate('configuration.integrations.vendorName'), type: 'text' },
      { columnDef: 'id', header: this.translocoService.translate('configuration.integrations.vendorId'), type: 'text' },
      { columnDef: 'edit', header: this.translocoService.translate('configuration.common.edit'), type: 'edit' },
    ];
    this.hasFullAccess =
      this.authService.isSuperAdmin() || this.authService.isCustomerService();
    this.loadTableData();
  }

  getVendorList(): void {
    this.lookupService
      .getVendors()
      .pipe(take(1))
      .subscribe((res: IVendor[]) => {
        if (res) {
          this.initializeTableData(res);
        }
      });
  }

  initializeTableData(res: IVendor[]): void {
    this.tableData = res;
    this.dataSource = new MatTableDataSource(res);
  }

  loadTableData() {
    this.getVendorList();
  }

  addVendor(): void {
    this.router.navigateByUrl('/config/integrations/add-vendor');
  }

  editVendor(event: any): void {
    const { data } = event;
    this.router.navigateByUrl(`/config/integrations/edit-vendor/${data.id}`);
  }
}
